/**
 * @generated SignedSource<<7077567e9d2ea201cd42283af123e6b6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment, RefetchableFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type NftPdpCreatorItems_creatorAddress$data = {
  readonly address: string | null;
  readonly createdItems: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly metadata: {
          readonly name?: string | null;
        } | null;
        readonly mostRecentAuction: {
          readonly serviceId: string | null;
          readonly " $fragmentSpreads": FragmentRefs<"NftItemTile_nftAuction">;
        } | null;
        readonly serviceId: string | null;
        readonly " $fragmentSpreads": FragmentRefs<"NftItemTile_nftItem">;
      } | null;
    } | null> | null;
  } | null;
  readonly id: string;
  readonly publicProfile: {
    readonly profileName: string | null;
  } | null;
  readonly " $fragmentType": "NftPdpCreatorItems_creatorAddress";
};
export type NftPdpCreatorItems_creatorAddress$key = {
  readonly " $data"?: NftPdpCreatorItems_creatorAddress$data;
  readonly " $fragmentSpreads": FragmentRefs<"NftPdpCreatorItems_creatorAddress">;
};

const node: ReaderFragment = (function(){
var v0 = [
  "createdItems"
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "serviceId",
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "after"
    },
    {
      "kind": "RootArgument",
      "name": "fetchUser"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "itemCount"
    },
    {
      "kind": "RootArgument",
      "name": "nftId"
    },
    {
      "kind": "RootArgument",
      "name": "userId"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": "itemCount",
        "cursor": "after",
        "direction": "forward",
        "path": (v0/*: any*/)
      }
    ],
    "refetch": {
      "connection": {
        "forward": {
          "count": "itemCount",
          "cursor": "after"
        },
        "backward": null,
        "path": (v0/*: any*/)
      },
      "fragmentPathInResult": [
        "node"
      ],
      "operation": require('./NftPdpCreatorItemsRefetchQuery.graphql'),
      "identifierField": "id"
    }
  },
  "name": "NftPdpCreatorItems_creatorAddress",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "address",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "PublicProfile",
      "kind": "LinkedField",
      "name": "publicProfile",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "profileName",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": "createdItems",
      "args": [
        {
          "items": [
            {
              "kind": "Variable",
              "name": "excludeItemIds.0",
              "variableName": "nftId"
            }
          ],
          "kind": "ListValue",
          "name": "excludeItemIds"
        }
      ],
      "concreteType": "EthereumAddressCreatedItemsConnection",
      "kind": "LinkedField",
      "name": "__NftCmsCreator_createdItems_connection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "EthereumAddressCreatedItemsEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "NftItem",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v1/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "concreteType": null,
                  "kind": "LinkedField",
                  "name": "metadata",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "InlineFragment",
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "name",
                          "storageKey": null
                        }
                      ],
                      "type": "NftDigitalArtMetadata",
                      "abstractKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "NftAuction",
                  "kind": "LinkedField",
                  "name": "mostRecentAuction",
                  "plural": false,
                  "selections": [
                    (v1/*: any*/),
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "NftItemTile_nftAuction"
                    }
                  ],
                  "storageKey": null
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "NftItemTile_nftItem"
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cursor",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PageInfo",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endCursor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasNextPage",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    }
  ],
  "type": "EthereumAddressType",
  "abstractKey": null
};
})();

(node as any).hash = "7012e94dc6247a8b6088730bcdb1063c";

export default node;
